(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react')) :
  typeof define === 'function' && define.amd ? define('@fdn/top_menu', ['react'], factory) :
  (global = global || self, global['@fdn/top_menu'] = factory(global.React));
}(this, (function (React) { 'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  var Desktop = function Desktop(props) {
    var _props$title_menu$lin, _props$title_menu;

    return /*#__PURE__*/React.createElement("div", {
      className: "top-menu".concat(props.is_hidden ? ' hidden' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "title"
    }, _typeof(props === null || props === void 0 ? void 0 : props.title_menu) === 'object' && !Array.isArray(props.title_menu) ? /*#__PURE__*/React.createElement("a", {
      href: (_props$title_menu$lin = props.title_menu.link) === null || _props$title_menu$lin === void 0 ? void 0 : _props$title_menu$lin.desktop,
      target: "__blank"
    }, (_props$title_menu = props.title_menu) === null || _props$title_menu === void 0 ? void 0 : _props$title_menu.text) : Array.isArray(props.title_menu) ? props.title_menu.map(function (item) {
      return /*#__PURE__*/React.createElement("a", {
        href: item.link.desktop,
        target: "__blank"
      }, item === null || item === void 0 ? void 0 : item.icon, " ", item.text);
    }) : null), /*#__PURE__*/React.createElement("div", {
      className: "menus"
    }, props.menus.length ? props.menus.map(function (item, id) {
      return /*#__PURE__*/React.createElement("a", {
        id: !!item.id ? item.id : null,
        href: !!item.link ? item.link : null,
        key: id,
        onClick: item.image ? props.handleAlloExplorer : null
      }, item.image ? /*#__PURE__*/React.createElement("img", {
        className: "item-image",
        src: item.image
      }) : null, item.text, item["new"] ? /*#__PURE__*/React.createElement("span", {
        className: "label-new"
      }, "NEW") : null);
    }) : null)), /*#__PURE__*/React.createElement("style", null, "\n          .top-menu {\n            background-color: ".concat(props.type === 'monochrome' ? '#000' : '#F9FAFB', ";\n            width: 100%;\n            transition: all .2s ease;\n            height: ").concat(props.type === 'monochrome' ? 'auto' : '24px', ";\n          }\n\n          .top-menu.hidden {\n            height: 0;\n          }\n\n          .top-menu .wrapper {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            height: ").concat(props.type === 'monochrome' ? 'auto' : '24px', ";\n            max-width: ").concat(props.menu_width, ";\n            margin: 0 auto;\n            padding: 0 15px;\n          }\n\n          .top-menu .wrapper .title {\n            display: flex;\n          }\n\n          .top-menu a {\n            font-family: Roboto, sans-serif;\n            font-size: ").concat(props.type === 'monochrome' ? '14px' : '12px', ";\n            color: ").concat(props.type === 'monochrome' ? '#FFF' : '#637381', ";\n            margin: ").concat(props.type === 'monochrome' ? '12px' : '0 12px', ";\n            text-decoration: none;\n            opacity: 1;\n            transition: all .2s ease;\n            height: ").concat(props.type === 'monochrome' ? '16.41px' : '15px', ";\n            display: flex;\n            align-items: center;\n          }\n\n          .top-menu a .item-image {\n            min-width: 24px;\n            min-height: 24px;\n            margin-right: 0.5rem;\n          }\n\n          .top-menu a .label-new {\n            font-family: Poppins;\n            font-size: 8px;\n            color: #FFF;\n            background-color: #D7254E;\n            height: 15px;\n            border-radius: 4px;\n            margin-left: 5px;\n            padding: 2px 4px;\n          }\n\n          .top-menu a:nth-child(1) {\n            margin-left: 0;\n          }\n\n          .top-menu a:nth-last-child(1) {\n            margin-right: 0;\n          }\n\n          .top-menu a:hover {\n            opacity: .4;\n          }\n\n          .top-menu .menus {\n            display: flex;\n            align-items: center;\n          }\n\n          ").concat(props.type === 'monochrome' ? ".top-menu .title a {\n              font-weight: bold;\n            }" : '', "\n        ")));
  };

  var Mobile = function Mobile(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: "top-menu"
    }, /*#__PURE__*/React.createElement("div", {
      className: "menus"
    }, props.menus.map(function (item, id) {
      return /*#__PURE__*/React.createElement("a", {
        id: !!item.id ? item.id : null,
        href: !!item.link ? item.link : null,
        key: id
      }, item.text, item["new"] ? /*#__PURE__*/React.createElement("span", {
        className: "label-new"
      }, "NEW") : null);
    })), /*#__PURE__*/React.createElement("div", {
      className: "title"
    }, _typeof(props === null || props === void 0 ? void 0 : props.title_menu) === 'object' && !Array.isArray(props.title_menu) ? /*#__PURE__*/React.createElement("a", {
      href: props.is_mobile.toLowerCase() == 'iphone' ? props.title_menu.link.mobile.ios : props.title_menu.link.mobile.android,
      target: "__blank"
    }, props.title_menu.text) : Array.isArray(props.title_menu) ? props.title_menu.map(function (item) {
      return /*#__PURE__*/React.createElement("a", {
        href: props.is_mobile.toLowerCase() == 'iphone' ? item.link.mobile.ios : item.link.mobile.android,
        target: "__blank"
      }, item.text);
    }) : null), /*#__PURE__*/React.createElement("style", null, "\n          .top-menu a {\n            font-family: Poppins, sans-serif;\n            font-style: normal;\n            font-weight: normal;\n            font-size: 12px;\n            line-height: 100%;\n            color: #000000;\n            margin: 0 0 12px 0;\n            display: block;\n            text-decoration: none;\n          }\n\n          .top-menu .title a {\n            margin-bottom: 0;\n          }\n\n          .top-menu .label-new {\n            color: rgb(255, 255, 255);\n            font-size: 10px;\n            font-family: Poppins;\n            margin-left: 5px;\n            background: rgb(215, 36, 78);\n            padding: 2px 4px;\n            border-radius: 4px;\n          }\n        "));
  };

  var TopMenu = function TopMenu(_ref) {
    var is_mobile = _ref.is_mobile,
        menu_width = _ref.menu_width,
        title_menu = _ref.title_menu,
        menus = _ref.menus,
        is_hidden = _ref.is_hidden,
        type = _ref.type,
        handleAlloExplorer = _ref.handleAlloExplorer;
    var props = {
      is_mobile: is_mobile || false,
      menu_width: menu_width || '1200px',
      title_menu: title_menu || {},
      menus: menus || {},
      is_hidden: is_hidden || false,
      type: type || null,
      handleAlloExplorer: handleAlloExplorer || function () {
        return false;
      }
    };

    if (is_mobile) {
      return /*#__PURE__*/React.createElement(Mobile, props);
    } else {
      return /*#__PURE__*/React.createElement(Desktop, props);
    }
  };

  return TopMenu;

})));
//# sourceMappingURL=top_menu.umd.js.map
